
<div *ngIf="isLoggedIn" class="p-d-flex p-jc-center">
  <p-card styleClass="p-shadow-5 p-mt-5 p-text-center animate__animated animate__fadeIn"
          [style]="{width: '560px'}">
    <ng-template pTemplate="header">
      <div class="title title-center">{{appFullName}}</div>
    </ng-template>

    <div>
      <h2 class="card-title">{{userFullname}}</h2>
      <p class="card-text">Welcome to {{appName}}! </p>
      <p class="card-text">Version: {{version}}</p>
      <p>{{currentTime}}</p>
    </div>
  </p-card>
</div>
